/* Gem Mint Gallery — base scripts */
(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Mobile menu — wires up every data-menu-toggle button (open AND close).
     Previously only the first matching element got a listener, which is why
     the close button inside the drawer didn't work. */
  function initMenuToggle() {
    var toggles = document.querySelectorAll('[data-menu-toggle]');
    var drawer  = document.querySelector('[data-menu-drawer]');
    if (!toggles.length || !drawer) return;

    function setOpen(open) {
      drawer.classList.toggle('is-open', open);
      toggles.forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(!drawer.classList.contains('is-open'));
      });
    });

    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { setOpen(false); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false);
    });
  }

  function initInlineForms() {
    document.querySelectorAll('form[data-inline-success]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = form.querySelector('button[type="submit"], button');
        if (btn && !btn.dataset.orig) {
          btn.dataset.orig = btn.textContent;
          setTimeout(function () { btn.textContent = 'Subscribed ✓'; }, 50);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initMenuToggle();
      initInlineForms();
    });
  } else {
    initReveal();
    initMenuToggle();
    initInlineForms();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      initReveal();
      initMenuToggle();
    });
  }
})();
